import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { SidenavItem } from 'src/app/shared/interfaces/sidenav-item.interface';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

export interface INavSearchItem {
  link: string;
  name: string;
  isVisible: boolean;
}

@Component({
    selector: 'fury-toolbar-search-bar',
    templateUrl: './toolbar-search-bar.component.html',
    styleUrls: ['./toolbar-search-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarSearchBarComponent extends BaseComponent implements OnInit {

  public input: string;
  public focused: boolean;
  public recentlyVisited: SidenavItem[] = [];
  public searchList: INavSearchItem[] = [];
  public componentList: INavSearchItem[] = [];
  public frequentlyVisitedList: INavSearchItem[] = [];

  constructor(
    private _router: Router,
    private _sidenavService: SidenavService,
  ) {
    super();
  }

  ngOnInit() {
    this._syncVisibleNavigation();

    this._sidenavService.items$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this._syncVisibleNavigation();
      });

    this._router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {

          const item = this._sidenavService.getItemByRoute(event.urlAfterRedirects);

          if (item) {
            const index = this.recentlyVisited.indexOf(item);
            if (index > -1) {
              this.recentlyVisited.splice(index, 1);
            }

            this.recentlyVisited.unshift(item);

            if (this.recentlyVisited.length > 5) {
              this.recentlyVisited.pop();
            }
          }
        }

      });
  }

  private _syncVisibleNavigation(): void {
    const visibleItems = this._flattenVisibleNavItems(this._sidenavService.items)
      .filter((item) => item.routeOrFunction && typeof item.routeOrFunction === 'string')
      .map((item) => ({
        link: item.routeOrFunction as string,
        name: item.name,
        isVisible: true
      }));

    const uniqueByRoute = new Map<string, INavSearchItem>();
    visibleItems.forEach((item) => {
      if (!uniqueByRoute.has(item.link)) {
        uniqueByRoute.set(item.link, item);
      }
    });

    this.componentList = Array.from(uniqueByRoute.values());
    this.searchList = [...this.componentList];
    this.frequentlyVisitedList = [...this.componentList];
  }

  private _flattenVisibleNavItems(items: SidenavItem[]): SidenavItem[] {
    return items.reduce((acc: SidenavItem[], item: SidenavItem) => {
      if (item.isVisible === false || item.type === 'subheading') {
        return acc;
      }

      acc.push(item);

      if (item.subItems && item.subItems.length > 0) {
        acc.push(...this._flattenVisibleNavItems(item.subItems));
      }

      return acc;
    }, []);
  }

  openDropdown() {
    this.focused = true;
  }

  closeDropdown() {
    this.focused = false;
  }

  onKeyup(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    if ((event.keyCode === 32 || event.keyCode === 8) && target.value.toString().trim().length <= 0) {
      this.searchList = [...this.componentList];
      return;
    }
    this.searchList = this.componentList.filter((item => item.isVisible && item.name.toLowerCase().includes(target.value.toString().trim().toLowerCase())));

  }
}
